import { RefreshCwIcon } from "lucide-react";
import { useCallback, useState } from "react";
import { toast } from "sonner";
import { syncAnalytics } from "@/api/analytics";
import { Button } from "@/components/ui/button";
import { useSyncEngine } from "@/sync/context";

/** Queues a forced content sync (import, metrics, comments, followers); results arrive via sync. */
export function useSyncContentNow(projectId: string | undefined) {
	const engine = useSyncEngine();
	const [syncing, setSyncing] = useState(false);
	const sync = useCallback(async () => {
		if (!projectId) return;
		setSyncing(true);
		try {
			await syncAnalytics(projectId);
			await engine.pull();
			toast.success("Syncing — metrics and comments update shortly");
		} catch (error) {
			toast.error("Couldn't start the sync", { description: (error as Error).message });
		} finally {
			setSyncing(false);
		}
	}, [engine, projectId]);
	return { sync, syncing };
}

export function SyncNowButton({
	projectId,
	variant = "outline",
	disabled,
}: {
	projectId: string;
	variant?: "outline" | "ghost";
	disabled?: boolean;
}) {
	const { sync, syncing } = useSyncContentNow(projectId);
	return (
		<Button
			type="button"
			size="sm"
			variant={variant}
			loading={syncing}
			disabled={disabled}
			onClick={() => void sync()}
		>
			<RefreshCwIcon />
			Sync now
		</Button>
	);
}
